import request from '@/apis/request'
const resource = 'vouchers'

export default {
  list: (params) => {
    return request.get('voucher-lists', { params })
  },

  get: (params) => {
    return request.get(`${resource}`, { params })
  },

  redeem: (data) => {
    return request.post(`${resource}/redeem`, data)
  },

  getSpinWheel: (params) => {
    return request.get(`${resource}/spin-wheels`, { params })
  },
}